import React, { useCallback, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { WhatsNewOverlay } from '../whatsnew/WhatsNewOverlay';
export function TitleBar({
  initialOpen = false
}: {
  initialOpen?: boolean;
}) {
  const [open, setOpen] = useState(initialOpen);
  const close = useCallback(() => setOpen(false), []);
  return <>
      <div className="relative z-[61] flex h-[26px] shrink-0 items-center border-b border-[#d4d4d4] bg-[#ececec] px-[10px]" data-id="element-59" data-mp="1u7vqw27os389">
        <div className="flex gap-[7px]" aria-hidden="true" data-id="element-60" data-mp="1q4pqhb79969p">
          <span className="h-[11px] w-[11px] rounded-full border border-[#e0443e] bg-[#ff5f57]" data-id="element-61" data-mp="1l6frepietlit" />
          <span className="h-[11px] w-[11px] rounded-full border border-[#dea123] bg-[#febc2e]" data-id="element-62" data-mp="1g7upmlniets9" />
          <span className="h-[11px] w-[11px] rounded-full border border-[#1aab29] bg-[#28c840]" data-id="element-63" data-mp="3fkp537tn7nwq" />
        </div>
        <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-haspopup="dialog" className="absolute left-1/2 flex -translate-x-1/2 items-center gap-[4px] rounded-[4px] px-[6px] py-[1px] text-[12px] font-semibold text-[#3d3d3d] transition-colors duration-150 hover:bg-black/5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-pf-blue-line" data-id="element-64" data-mp="3al43epn391gb">
          
          <span className={open ? '' : 'pf-halogen'} data-id="element-65" data-mp="1du1n8m6ud5c7">Click to see what changed</span>
          <ChevronDownIcon className={`h-[13px] w-[13px] transition-transform duration-200 ${open ? 'rotate-180' : ''}`} strokeWidth={2.6} aria-hidden="true" data-id="element-66" data-mp="21kovj8ko5wza" />
          
        </button>
      </div>
      <AnimatePresence data-id="element-67" data-mp="1rrq7brt348g7">{open && <WhatsNewOverlay onClose={close} data-id="element-68" data-mp="1wsdu21aa634m" />}</AnimatePresence>
    </>;
}